import cx from "classnames";
import { memo } from "react";
import { MinusIcon, PlusIcon } from "@/icons";
import styles from "../FullscreenPresentationLayout.module.scss";
import type { ZoomDirection } from "../types";

type ZoomControlProps = {
    zoom: number;
    onChangeZoom: (direction: ZoomDirection) => void;
};

export const ZoomControl = memo(({ zoom, onChangeZoom }: ZoomControlProps) => {
    return (
        <div className={styles.zoomControl}>
            <button
                className={cx(styles.navigationButton, styles.minus)}
                type="button"
                onClick={() => onChangeZoom("out")}
            >
                <MinusIcon />
            </button>

            <div className={styles.zoom}>{zoom}%</div>

            <button
                className={styles.navigationButton}
                type="button"
                onClick={() => onChangeZoom("in")}
            >
                <PlusIcon />
            </button>
        </div>
    );
});
